import { render, staticRenderFns } from "./FormAddTodo.vue?vue&type=template&id=6cd0447f&"
import script from "./FormAddTodo.vue?vue&type=script&lang=js&"
export * from "./FormAddTodo.vue?vue&type=script&lang=js&"
import style0 from "./FormAddTodo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FormAddTodo.vue"
export default component.exports